import React, { useEffect, useState, useCallback } from 'react';
import { Table, SelectPicker, FlexboxGrid, Input } from 'rsuite';
import { toast } from 'react-toastify';

import pt from 'date-fns/locale/pt-BR';
import { useDebouncedCallback } from 'use-debounce/lib';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { Container } from '~/styles/tabela1';
import api from '~/services/api';
import CelulaAcao from '~/components/Celulas/components/CelulaAcao';
import SearchInputTable from '~/components/SearchInputTable';
import SelectState from '~/components/SelectState';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { MdOutlineAddBusiness } from 'react-icons/md';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { ImBlocked } from 'react-icons/im';
import EditarEstabelecimento from './EditarEstabelecimento';
import MetricsCards from '../../components/MetricCards';
import PageHeader from '../../components/PageHeader';
import AdvancedFilters from '../../components/AdvancedFilters';

const { HeaderCell, Column, Cell } = Table;

function Estabelecimentos() {
  const [estabelecimentos, setEstabelecimentos] = useState({
    lista: [],
    quantidade: 0,
  });
  const [estabelecimentoEditando, setEstabelecimentoEditando] = useState();
  const [showEditarEstabelecimento, setShowEditarEstabelecimento] =
    useState(false);
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [cidadeInput, setCidadeInput] = useState('');
  const [cidade, setCidade] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [textodigitado, setTextoDigitado] = useState();
  const [pagina, setPagina] = useState(1);
  const [atributoSelecionado, setAtributoSelecioando] =
    useState('nome_fantasia');

  const atributosFiltro = [
    {
      label: 'Nome Fantasia',
      value: 'nome_fantasia',
    },
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'Cnpj',
      value: 'cpf_cnpj',
    },
    {
      label: 'Cidade',
      value: 'cidade',
    },
  ];

  const [orderBy, setOrderBy] = useState('order by data_criacao desc');

  const cidadeDebounce =
    useDebouncedCallback(setCidade, 500);

  const buscarEstabelecimentos = useCallback(async () => {
    setCarregando(true);
    if (estabelecimentos.quantidade > 0 && estabelecimentos.lista.length === 0) setPagina(1)
    try {
      const resposta = await api.get('estabelecimentos', {
        params: {
          [atributoSelecionado]: textodigitado,
          pagina,
          estado: estadoSelecionado,
          orderBy,
          cidade
        },
      });
      setEstabelecimentos({
        quantidade: resposta.data.quantidade,
        lista: resposta.data.lista.map((cliente) => ({
          ...cliente,
          data_criacao: formatDistanceToNow(new Date(cliente.data_criacao), {
            locale: pt,
          }),
          estado: cliente.endereco.bairro.cidade.estado.uf,
          cidade: cliente.endereco.bairro.cidade.cidade,
        })),
      });
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }, [atributoSelecionado, textodigitado, pagina, estadoSelecionado, orderBy, estabelecimentos.quantidade, setPagina, cidade]);

  useEffect(() => {
    buscarEstabelecimentos();
  }, [buscarEstabelecimentos]);

  function abrirEditarEstabelecimento(pedido) {
    setEstabelecimentoEditando(pedido);
    setShowEditarEstabelecimento(true);
  }

  function fecharEditarEstabelecimento() {
    buscarEstabelecimentos();
    setShowEditarEstabelecimento(false);
  }

  console.log(estabelecimentos, 'estabelecimentos 1111111');
  return (
    <Container>
      <PageHeader
        title="Clientes"
        subtitle="Estabelecimentos cadastrados"
      />
      <MetricsCards
        items={[
          {
            title: 'Total Estabelecimentos',
            value: estabelecimentos.quantidade,
            icon: <MdOutlineAddBusiness size="30px" />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Quantidade de Perfis Bloqueados',
            value: '-',
            icon: <ImBlocked size="30px" />,
            background: '#FADBD8',
            color: '#D32F2F'
          },
          {
            title: 'Cidade com mais cadastros',
            value: '-',
            icon: <FaMapMarkedAlt size="30px" />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Cidade com menos cadastros',
            value: '-',
            icon: <FaMapMarkedAlt size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />
      <AdvancedFilters
        // activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable
              place='Buscar estabelecimento...'
              setTextoDigitado={setTextoDigitado}
              estilo={{ width: '700px' }}
            />
            <SelectPicker
              appearance="default"
              // style={{ marginRight: '15px' }}
              searchable={false}
              data={atributosFiltro}
              value={atributoSelecionado}
              cleanable={false}
              onChange={(value) => setAtributoSelecioando(value)}
            />
            <Input
              style={{ width: '250px' }}
              placeholder="Cidade"
              onChange={(value) => {
                setCidadeInput(value);
                cidadeDebounce.callback(value);
              }}
              value={cidadeInput}
            />
            <SelectState
              selectedState={estadoSelecionado}
              setSelectedStates={setEstadoSelecionado}
            />
          </>
        }
      />

      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={estabelecimentos.lista}
          quantidade={estabelecimentos.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
        >
          <Column resizable width={60}>
            <HeaderCell>Editar</HeaderCell>
            <CelulaAcao
              dataKey="id"
              onEditar={(estabelecimento) => {
                abrirEditarEstabelecimento(estabelecimento);
              }}
            />
          </Column>
          <Column resizable width={240} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Nome Fantasia' tooltip='Nome Fantasia' />
            </HeaderCell>
            <Cell dataKey="nome_fantasia" />
          </Column>

          <Column resizable width={240} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Email' tooltip='Email' />
            </HeaderCell>
            <Cell dataKey="email" />
          </Column>

          <Column resizable width={240} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Cpf/Cnpj' tooltip='Cpf/Cnpj' />
            </HeaderCell>
            <Cell dataKey="cpf_cnpj" />
          </Column>
          <Column resizable width={150} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Cidade' tooltip='Cidade' />
            </HeaderCell>
            <Cell dataKey="cidade" />
          </Column>
          <Column resizable width={100} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Estado' tooltip='Estado' />
            </HeaderCell>
            <Cell dataKey="estado" />
          </Column>
          <Column resizable width={150} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Tempo Cadastro' tooltip='Tempo Cadastro' />
            </HeaderCell>
            <Cell dataKey="data_criacao" />
          </Column>
        </TablePagination>
      </FlexboxGrid>
      <EditarEstabelecimento
        idEstabelecimento={
          estabelecimentoEditando && estabelecimentoEditando.id
        }
        showEditarEstabelecimento={showEditarEstabelecimento}
        setShowEditarEstabelecimento={setShowEditarEstabelecimento}
        // eslint-disable-next-line react/jsx-no-bind
        fecharEditarEstabelecimento={fecharEditarEstabelecimento}
      />
    </Container>
  );
}

export default Estabelecimentos;
